import React from "react";
import { PartnerListPageContent, PartnerListPageStateProvider } from ".";

export const PartnerListPage = () => {
  return (
    <PartnerListPageStateProvider>
      <PartnerListPageContent></PartnerListPageContent>
    </PartnerListPageStateProvider>
  );
};
